import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const adService = {
  // ─── Public (no auth) ─────────────────────────────────────────────────────

  // Get active ads for a placement
  getActiveAds: async (placement = 'homepage_banner') => {
    const response = await api.get(API_ENDPOINTS.ADS.ACTIVE, { params: { placement } });
    return response.data;
  },

  // Track ad click
  trackClick: async (adId) => {
    const response = await api.post(API_ENDPOINTS.ADS.CLICK(adId));
    return response.data;
  },

  // Submit giveaway entry
  submitGiveaway: async (phone) => {
    const response = await api.post(API_ENDPOINTS.ADS.GIVEAWAY, { phone });
    return response.data;
  },

  // ─── Admin ────────────────────────────────────────────────────────────────

  // Get all ads (admin)
  getAll: async (page = 1, limit = 20, filters = {}) => {
    const response = await api.get(API_ENDPOINTS.ADS.ADMIN_ALL, { params: { page, limit, ...filters } });
    return response.data;
  },

  // Create ad with image upload (admin)
  create: async (formData) => {
    const response = await api.post(API_ENDPOINTS.ADS.ADMIN_CREATE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Update ad (admin)
  update: async (id, formData) => {
    const response = await api.put(API_ENDPOINTS.ADS.ADMIN_UPDATE(id), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Delete ad (admin)
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.ADS.ADMIN_DELETE(id));
    return response.data;
  },

  // Toggle ad active status (admin)
  toggleStatus: async (id) => {
    const response = await api.patch(API_ENDPOINTS.ADS.ADMIN_TOGGLE(id));
    return response.data;
  },

  // Get giveaway entries (admin)
  getGiveawayEntries: async (page = 1, limit = 20, search = '') => {
    const params = { page, limit };
    if (search) params.search = search;
    const response = await api.get(API_ENDPOINTS.ADS.ADMIN_GIVEAWAY_ENTRIES, { params });
    return response.data;
  },

  // Delete giveaway entry (admin)
  deleteGiveawayEntry: async (id) => {
    const response = await api.delete(API_ENDPOINTS.ADS.ADMIN_DELETE_GIVEAWAY_ENTRY(id));
    return response.data;
  },

  // Get giveaway settings (public/admin)
  getGiveawaySettings: async () => {
    const response = await api.get(API_ENDPOINTS.ADS.GIVEAWAY_SETTINGS);
    return response.data;
  },

  // Update giveaway settings (admin)
  updateGiveawaySettings: async (formData) => {
    const response = await api.put(API_ENDPOINTS.ADS.GIVEAWAY_SETTINGS, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default adService;
